<template>
  <v-container fluid style="padding:0">
    <div class="social-cut">
      <div class="d-flex flex-column">
        <a href="https://www.facebook.com/HortusBoxDesign" target="_blank">
          <v-icon color="#0b755f" x-large class="pa-1">mdi-facebook</v-icon>
        </a>
        <a href="https://www.instagram.com/hortusboxdesign/" target="_blank">
          <v-icon color="#0b755f" x-large class="pa-1">mdi-instagram</v-icon>
        </a>
        <a href="https://www.pinterest.fr/HortusBox/_created/" target="_blank">
          <v-icon color="#0b755f" x-large class="pa-1">mdi-pinterest</v-icon>
        </a>
        <a href="https://www.linkedin.com/company/hortusbox/" target="_blank">
          <v-icon color="#0b755f" x-large class="pa-1">mdi-linkedin</v-icon>
        </a>
      </div>
    </div>

    <section style="padding:0">
      <Masterhead2022 />
    </section>

    <section class="section">
      <div class="d-flex justify-center">
        <div style="max-width:800px; text-align:center">
          <div v-html="description"></div>
        </div>
      </div>
    </section>
    
    <section class="section section--colored">
      <Human />
    </section>
    
    <section class="section--light">
      <Users/>
    </section>

    <section>
      <p>Vous avez envie de découvrir quel est votre style ? Pas de problèmes !</p>
      <h3>Effectuez notre quizz pour trouver votre style.</h3>
      <!-- <Users/> -->
      <br/>
      <br/>
      <v-btn rounded color="#ef6758" class="call2action" :to="{path: '/trouver-mon-style'}">
        Trouver mon style
      </v-btn>
    </section>

    <section>
      <Partners/>
    </section>

    <section v-if="false" class="section--colored">
      <OurOffers />
    </section>
    <!-- <section>
      <Ccm/>
    </section>
 -->
    

    <!-- <section class="section--light">
      <More/>
    </section> -->

    <section>
      <Commit />
    </section>

    <section class="section--colored">
      <Todo/>
    </section>

    <section>
      <v-row align="center" justify="center" class="my-6">
        <v-btn color="#ef6758" style="color:white" rounded x-large link :href="livrable" target="_blank">
          Exemple de projet Maison
        </v-btn>
      </v-row>
    </section>


    <section v-if="false" class="section--colored">
      <Contact />
    </section>


    <section v-if="false" class="section--colored">
      <Us/>
    </section>


    <section v-if="false">
      <Press />
    </section>

    <section v-if="false" class="section section--colored">
      <KeepInTouch />
    </section>

    <!-- <section>
      <Collab/>
    </section> -->
    <!-- <section class="section--light">
      <About/>
    </section> -->

    <!-- <v-btn
      v-if="!popupPromo"
      color="#FF696F"
      class="fab-project"
      dark
      fixed
      bottom
      right
      fab
      @click="clickOnFab"
      v-html="call2action.split(' ').join('<br/>')"
    >
    </v-btn> -->

  </v-container>
  
</template>

<script>
// @ is an alias to /src

import {mapGetters} from 'vuex'

// import Ccm from '../components/home/Ccm'
import Todo from '../components/home/Todo'
import Users from '../components/home/Users'
// import More from '../components/home/More'
import Commit from '../components/home/Commit'
import Press from '../components/home/Press'
import Partners from '../components/home/Partners'
import Us from '../components/home/Us'
// import About from '../components/home/About'
import Masterhead2022 from '../components/home/Masterhead2022'
// import Collab from '../components/home/Collab'
import Human from '../components/home/Human.vue'
import Contact from '../components/home/Contact.vue'
import OurOffers from '../components/offer/OurOffers.vue'
import KeepInTouch from '../components/home/KeepInTouch.vue'

// const KHasBeenVisitedPromo = 'hasBeenVisitedPromo'


export default {
  name: 'Home',

  components: {
    // Ccm,
    Users,
    Todo,
    // More,
    Commit,
    Partners,
    Us,
    // Collab,
    Press,
    Human,
    Contact,
    OurOffers,
    // About,
    Masterhead2022,
    KeepInTouch
  },

  data: () => ({
    popupPromo: false,
    numberOfReload: 3,
  }),

  computed: {
    ...mapGetters('strapi', ['livrable']),
    ...mapGetters('app', ['isPartner', 'homeData']),
    // ...mapGetters('strapi', ['promoPrice', 'promoDeadline']),
    ...mapGetters('strapiv2', ['call2action', 'description']),
  },

  // watch: {
  //   promoPrice: function () {
  //     this.showPopUpIfRequired()
  //   }
  // },

  methods: {
    // clickOnFab () {
    //   this.$router.push('/choix')
    //   // this.$router.push('/mon-projet')
    // },
    // getHasBeenVisited () {
    //   const hasBeenVisitedPromoStr = localStorage.getItem(KHasBeenVisitedPromo)
    //   const hasBeenVisitedPromo = Number(hasBeenVisitedPromoStr)
    //   return isNaN(hasBeenVisitedPromo) ? 0 : hasBeenVisitedPromo
    // },
    // setHasBeenVisited () {
    //   const nbVisited = this.getHasBeenVisited()
    //   localStorage.setItem(KHasBeenVisitedPromo, nbVisited+1)
    // },
    // showPopUpIfRequired() {
    //   // if (this.isPartner) {
    //   //   return
    //   // }
    //   if (this.promoIsActive) {
    //     this.popupPromo = true
    //   }
    //   // const nbVisited = this.getHasBeenVisited()
    //   // if (nbVisited >= this.numberOfReload) {
    //   //   this.popupPromo = true
    //   //   localStorage.setItem(KHasBeenVisitedPromo, 0)
    //   // } else {
    //   //   this.setHasBeenVisited()
    //   // }
    // },
  },
  
  async mounted () {
    localStorage.setItem('lp-version', '202205')
    // this.showPopUpIfRequired()
    if (this.$route.path === '/contact') {
      this.$store.commit('showContact', {from: 'home', path: this.$route.path})
    }
  }
}
</script>

<style scoped>
.social-cut {
  position: fixed;
  top: 10em;
  left: 0px;
  z-index:1000;
  color: #0b755f;
  background-color: rgba(255, 255, 255, 0.4);
}

.social-cut a {
  text-decoration: none;
}

section {
  padding: 3em 0;
  text-align:center;
}

a {
  color: white!important;
}

.section--light {
  color: #3E524F;
  background-color:#d3e8db;
  background-color:#d3e8db;
  text-align:center;
  padding: 3em 0;
  font-weight: normal!important;
}

.fab-project {
  width:100px;
  height:100px;
  right:5px;
  font-size:14px;
}


@media (min-width: 600px) {
  .fab-project {
    width:140px;
    height:140px;
    font-size:20px;
  }
}
</style>